import { render, staticRenderFns } from "./groupmaker.vue?vue&type=template&id=7283c3d9&"
import script from "./groupmaker.vue?vue&type=script&lang=js&"
export * from "./groupmaker.vue?vue&type=script&lang=js&"
import style0 from "./groupmaker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports